var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CChartPie',{attrs:{"datasets":_vm.defaultDatasets,"labels":['VueJs', 'EmberJs', 'ReactJs', 'AngularJs']}})
}
var staticRenderFns = []

export { render, staticRenderFns }